<script>
import Label from "../form-components/Label.vue";
import Multiselect from "vue-multiselect";
import * as categoryService from '../../service/category.service';

export default {
  props: {
    item_key: {
      type: String,
      required: false,
    },
    item_value: {
      // type: String,
      required: false,
    },
    item: {
      type: Object,
      required: false,
    },
    submitted: {
      type: Boolean,
      required: false,
    },
    validation: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true
    },
    updateSubgroupValue: {
      type: Function,
      required: false
    },
    filterValue: {
      required: true
    }, 
  },
  components: {
    Label,
    Multiselect,
  },
  data() {
    return {
      value: null,
      subgroup: null,
      options: [],
      group_label: {
        label: 'Group',
        placeholder: 'Select Group'
      },
      subgroup_label: {
        label: 'Sub-group',
        placeholder: 'Select Sub-Group'
      }
    };
  },
  watch: {
    filterValue(val) {
      this.value = this.options.filter(x => x.id == val)[0]
    },
    value(val) {
      if(val && val.id) this.updateValue(val.id)
      this.subgroup = null
    },
    subgroup(val) {
      if(val && val.id) {
        this.updateSubgroupValue(val.id)
      } else {
        this.updateSubgroupValue(null)
      }
    }
  },
  methods: {
    async getOptions() {
      let data = await categoryService.get(this.$route.params.categoryId)
      this.options = data.additionalProp1.groups;
      if(this.options && this.options.length) this.value = this.options[0]
    },
  },
  mounted() {
    this.getOptions();
  },
};
</script>
<template>
  <div>
    <Label :item="group_label"/>
    <multiselect
      track-by="title"
      label="title"
      class="mb-3"
      v-model="value"
      :options="options"
      :searchable="options.length > 5 ? true : false"
      :close-on-select="true"
      :show-labels="false"
      :placeholder="group_label.placeholder"
      :allow-empty="false"
      :preselectFirst="true"
      open-direction="bottom"
    >
      <template slot="singleLabel" slot-scope="{ option }"
        ><strong>{{ option.title }}</strong></template
      >
    </multiselect>
    <Label v-if="!item.withoutSubGroups" :item="subgroup_label"/>
    <multiselect
      v-if="!item.withoutSubGroups"
      class="mb-3"
      track-by="title"
      label="title"
      v-model="subgroup"
      :options="value && value.subgroups ? value.subgroups : []"
      :searchable="false"
      :close-on-select="true"
      :show-labels="false"
      :placeholder="subgroup_label.placeholder"
      :allow-empty="true"
      :preselectFirst="false"
      open-direction="bottom"
    >
      <template slot="singleLabel" slot-scope="{ option }"
        ><strong>{{ option.title }}</strong></template
      >
    </multiselect>
  </div>
</template>



